import type { Toast, ToastOptions } from 'react-hot-toast'

export type AlertToastSeverity =
  | 'success'
  | 'error'
  | 'info'
  | 'warning'
  | 'loading'

// info et warning sont des toasts « blank » pour react-hot-toast : la sévérité voyage dans la classe.
const SEVERITY_CLASS_PREFIX = 'nabu-toast--'
const SEVERITIES: readonly AlertToastSeverity[] = [
  'success',
  'error',
  'info',
  'warning',
  'loading',
]

export const getAlertToastOptions = (
  severity: AlertToastSeverity,
  options?: ToastOptions
): ToastOptions => ({
  ...options,
  className: `${SEVERITY_CLASS_PREFIX}${severity}`,
})

/** Sévérité à afficher : le type de react-hot-toast quand il en porte une, sinon celle de la classe. */
export const getToastSeverity = (t: Toast): AlertToastSeverity => {
  if (t.type === 'success' || t.type === 'error' || t.type === 'loading') {
    return t.type
  }
  const fromClass = t.className?.startsWith(SEVERITY_CLASS_PREFIX)
    ? t.className.slice(SEVERITY_CLASS_PREFIX.length)
    : undefined
  return SEVERITIES.find((s) => s === fromClass) ?? 'info'
}
